import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { PostType } from '@/graphql/generated/types.generated';
import { AndiePlanningIdeasConfirmation } from './AndiePlanningIdeasConfirmation';
import { ActionWorkflowAi } from '@/ai/types/action-workflow-ai';
import { TipsAndUpdatesRounded } from '@mui/icons-material';
import { ActionResponseStatusAi } from '@/ai/enum/action-response-status-ai';

type ActionResponse = ActionWorkflowAi<{
    dates: {
        topic: string;
        dateTime: string;
        topicJustification: string;
        postTypeString: PostType;
        dateJustification: string;
        postTypeJustification: string;
    }[];
}>;

type ActionArgs = {
    userInput: string;
    planningIntervalDays: string;
    privateProfileId?: string;
};

export type AndieGeneratePlanningWorkflowProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGeneratePlanningWorkflow = (props: AndieGeneratePlanningWorkflowProps) => {
    const { t } = useTranslation();
    const isComplete = props.status === ActionResponseStatusAi.COMPLETE;
    const hasPlanningDates = Array.isArray(props.result?.result?.dates);
    const shouldRenderPlanningPreview = !isComplete || hasPlanningDates;

    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.generate-planning.title')}
            icon={<TipsAndUpdatesRounded sx={{ fontSize: 16 }} />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={(args) => [
                t('andie.tool.generate-planning.loading', { value: Number(args?.planningIntervalDays) || 0 }),
            ]}
            completeMessage={({ args }) =>
                t('andie.tool.generate-planning.complete', { value: Number(args?.planningIntervalDays) || 0 })
            }
            additionalComponent={shouldRenderPlanningPreview ? AndiePlanningIdeasConfirmation : undefined}
            {...props}
        />
    );
};

export default AndieGeneratePlanningWorkflow;
